var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('p',{staticClass:"ma-0 secondary-text--text"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"ma-0 mt-1 primary-text--text"},[_c('strong',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }